import type { Feature, FeatureCollection } from 'geojson';

export function normaliseFeatureCollectionResponse(raw: unknown): FeatureCollection {
    if (typeof raw !== 'object' || raw === null) {
        return { type: 'FeatureCollection', features: [] };
    }

    const candidate = raw as Record<string, unknown>;
    if (candidate['type'] !== 'FeatureCollection') {
        return { type: 'FeatureCollection', features: [] };
    }
    if (!Array.isArray(candidate['features'])) {
        return { type: 'FeatureCollection', features: [] };
    }

    const features = (candidate['features'] as unknown[]).filter(
        (f): f is Feature =>
            typeof f === 'object' &&
            f !== null &&
            (f as Record<string, unknown>)['type'] === 'Feature' &&
            typeof (f as Record<string, unknown>)['geometry'] === 'object' &&
            (f as Record<string, unknown>)['geometry'] !== null,
    );

    return { type: 'FeatureCollection', features };
}
